/**
* @ngdoc directive
* @name Autofocus Child Input
*
* @description
  Focus element child input after render
*
* @scope
* @param {Boolean} autofocusChildInput - optional do not focus (on mobile for example)
*/

(function () {
  'use strict';

  autofocusChildInput.$inject = ["$timeout"];
  app.directive('autofocusChildInput', autofocusChildInput);

  function autofocusChildInput($timeout) {
    return {
      scope: { autofocusChildInput: '=?' },
      link: function (scope, element) {
        $timeout(function () {
          if (scope.autofocusChildInput === undefined || scope.autofocusChildInput === true )
            element.find('input')[0].focus();
        });
      }
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/autofocusChildInput.js